import { NuxtCookies } from 'cookie-universal-nuxt'
import { Store } from 'vuex'
import { RootState } from '@/store'
import * as types from '@/store/message/types'
import MessageEntity, { IMessageProps } from '@/entities/Message'
import { IResponseProps } from '@/entities/Response'

export default class MessageRepository {
  private cookies: NuxtCookies
  private store: Store<RootState>

  constructor(cookies: NuxtCookies, store: Store<RootState>) {
    this.cookies = cookies
    this.store = store
  }

  set data(value: IResponseProps<IMessageProps>) {
    this.store.commit(new types.Store(value))
  }

  get data(): IResponseProps<IMessageProps> {
    return this.store.state.message.response
  }

  set current(value: IMessageProps | null) {
    this.store.commit(new types.Current(value))
  }

  get current(): IMessageProps | null {
    return this.store.state.message.current
  }

  get entity(): MessageEntity {
    return new MessageEntity(this.store.state.message.current)
  }

  set filter(value: string) {
    this.store.commit(new types.Filter(value))
  }

  get filter(): string {
    return this.store.state.message.filter
  }
}
